"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultPalette = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("./utils");
var _ColorBox = require("./ColorBox");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const S = {
  Wrapper: _styledComponents.default.div`
        display: flex;
        flex-direction: column;
    `,
  ColorsGroup: _styledComponents.default.div`
        margin: 0 2px;
        border: 1px solid var(--border-color);
        border-radius: 1px;
    `,
  ColorsSection: _styledComponents.default.div`
        display: flex;
    `,
  BlackWhiteSection: _styledComponents.default.div`
        display: flex;
        margin-top: 7px;
    `
};
function paletteGrouping(colors, perRow = 12) {
  let maxJ = Math.floor(colors.length / perRow);
  let res = [];
  for (let i = 0; i < 12; i++) {
    const temp = [];
    for (let j = 0; j < maxJ; j++) {
      temp.push(colors[12 * j + i]);
    }
    res.push(temp);
  }
  return res;
}
const DefaultPalette = ({
  selectedColor,
  onChange
}) => {
  const getIsSelected = c => {
    return selectedColor && selectedColor.compare(c);
  };
  return /*#__PURE__*/_react.default.createElement(S.Wrapper, null, /*#__PURE__*/_react.default.createElement(S.ColorsSection, null, paletteGrouping(_utils.DEFAULT_COLORS).map((group, groupIndex) => /*#__PURE__*/_react.default.createElement(S.ColorsGroup, {
    key: groupIndex
  }, group.map((c, i) => {
    return /*#__PURE__*/_react.default.createElement(_ColorBox.ColorBox, {
      key: `g-${groupIndex}-c-${i}`,
      color: c,
      isSelected: getIsSelected(c),
      onClick: () => onChange(c)
    });
  })))), /*#__PURE__*/_react.default.createElement(S.BlackWhiteSection, null, /*#__PURE__*/_react.default.createElement(_ColorBox.SingleColorBox, {
    key: 'default-color-black',
    color: _utils.RGBColor.black,
    isSelected: getIsSelected(_utils.RGBColor.black),
    onClick: () => onChange(_utils.RGBColor.black)
  }), /*#__PURE__*/_react.default.createElement(_ColorBox.SingleColorBox, {
    key: 'default-color-white',
    color: _utils.RGBColor.white,
    isSelected: getIsSelected(_utils.RGBColor.white),
    onClick: () => onChange(_utils.RGBColor.white)
  }), /*#__PURE__*/_react.default.createElement(_ColorBox.SingleColorBox, {
    key: 'default-color-cyan',
    color: _utils.RGBColor.DEFAULT_COLOR,
    isSelected: getIsSelected(_utils.RGBColor.DEFAULT_COLOR),
    onClick: () => onChange(_utils.RGBColor.DEFAULT_COLOR)
  })));
};
exports.DefaultPalette = DefaultPalette;
DefaultPalette.propTypes = {
  selectedColor: _propTypes.default.instanceOf(_utils.RGBColor),
  onChange: _propTypes.default.func,
  groups: _propTypes.default.array
};